import { connect } from 'react-redux'
import { getMarktplaats, updateMarktplaatsFeatures } from 'redux/actions/data'
import MarktplaatsViewOverlay from 'components/molecules/marktplaats-view-overlay'

const mapStateToProps = (state, ownProps) => {
    const { carId } = ownProps
    const marktplaatsData = state.data.marktplaats?.data?.rows?.find(
        (row) => row.auto_id === carId
    )

    return {
        marktplaatsData,
    }
}

const mapDispatchToProps = {
    getMarktplaats,
    updateMarktplaatsFeatures,
}

export default connect(mapStateToProps, mapDispatchToProps)(MarktplaatsViewOverlay) 